import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../components/Loader/Loader";
import useApi from "../hook/useApi";
import { toast } from "react-toastify";
import { userPageType } from "../utils/enum";
import { copyToClipboard, getHeaders, trimAddress, ValidateInputs } from "../utils/helper";
import { isValidEVMAddress } from "../utils/evm.helper";
import "react-phone-input-2/lib/style.css";
import { IoCopyOutline } from "react-icons/io5";
import validator from "validator";
import { Icon } from "@iconify/react/dist/iconify.js";
import Swal from "sweetalert2";
import { BASE_URL, STANDARD_IMAGE_URL } from "../utils/constant";
import axios from "axios";

const ViewProfileLayer = () => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState("");
  const { id } = useParams();
  const location = useLocation();
  const { AsyncGetApiCall } = useApi();
  const [errors, setErrors] = useState({});
  const from = location.state?.from;
  const [formData, setFormData] = useState({
    name: "",
    userName: "",
    bio: "",
    websiteUrl: "",
    twitterUrl: "",
    telegramUrl: "",
  });

  const [images, setImages] = useState({
    coverImage: "",
    coverImageUrl: "",
    profileImage: "",
    profileImageUrl: "",
  });

  const handleValues = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    const updatedInputs = ValidateInputs(name, value, errors);
    setErrors(updatedInputs);
  };

  const validate = () => {
    const newErrors = {};

    if (!formData?.name.trim()) {
      newErrors.name = "Name is required";
    }
    else if (formData?.name.trim().length > 50) {
      newErrors.name = "Name cannot exceed 50 characters";
    }
    else {
      delete newErrors.name;
    }

    if (!formData?.userName.trim()) {
      newErrors.userName = "User name is required";
    }
    else if (formData?.userName.trim().length > 50) {
      newErrors.userName = "User name cannot exceed 50 characters";
    }
    else {
      delete newErrors.userName;
    }

    if (!formData?.bio.trim()) {
      newErrors.bio = "Bio is required";
    }
    else if (formData?.bio.trim().length > 200) {
      newErrors.bio = "Bio cannot exceed 200 characters";
    }
    else {
      delete newErrors.bio;
    }

    if (!formData?.websiteUrl.trim()) {
      newErrors.websiteUrl = "Website URL is required";
    }
    else if (!validator.isURL(formData?.websiteUrl.trim())) {
      newErrors.websiteUrl = "Website URL is not valid";
    }
    else if (formData?.websiteUrl.trim().length > 200) {
      newErrors.websiteUrl = "Website URL cannot exceed 200 characters";
    }
    else {
      delete newErrors.websiteUrl;
    }

    if (!formData?.twitterUrl.trim()) {
      newErrors.twitterUrl = "Twitter URL is required";
    }
    else if (!validator.isURL(formData?.twitterUrl.trim())) {
      newErrors.twitterUrl = "Twitter URL is not valid";
    }
    else if (formData?.twitterUrl.trim().length > 200) {
      newErrors.twitterUrl = "Twitter URL cannot exceed 200 characters";
    }
    else {
      delete newErrors.twitterUrl;
    }

    if (!formData?.telegramUrl.trim()) {
      newErrors.telegramUrl = "Telegram URL is required";
    }
    else if (!validator.isURL(formData?.telegramUrl.trim())) {
      newErrors.telegramUrl = "Telegram URL is not valid";
    }
    else if (formData?.telegramUrl.trim().length > 200) {
      newErrors.telegramUrl = "Telegram URL cannot exceed 200 characters";
    }
    else {
      delete newErrors.telegramUrl;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fetchUser = async () => {
    setLoading(true);

    const result = await AsyncGetApiCall(`/admin/view-user?id=${id}`);

    console.log("result of fetchUser: ", result);

    if (result.errors) {
      toast.error(result.errors[0]);
    } else if (result.success) {
      setUser(result?.data);
      setFormData({
        name: result?.data?.name || "",
        userName: result?.data?.userName || "",
        bio: result?.data?.bio || "",
        walletAddress: result?.data?.walletAddress || "",
        websiteUrl: result?.data?.websiteUrl || "",
        twitterUrl: result?.data?.twitterUrl || "",
        telegramUrl: result?.data?.telegramUrl || "",
      });
      setImages((prev) => ({
        ...prev,
        coverImageUrl: result?.data?.coverImage ? `${BASE_URL}/${result?.data?.coverImage}` : "",
        profileImageUrl: result?.data?.profileImage ? `${BASE_URL}/${result?.data?.profileImage}` : "",
      }));
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const handleImage = async (type) => {
    const result = await Swal.fire({
      text: "Max File Size is 5 MB, Only PNG, JPG and JPEG files are allowed",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Update ${type} Image`,
      cancelButtonText: 'Cancel',
    })
    if (result?.isConfirmed) {
      const result = await uploadImage(type);
      console.log("result : ", result);
    }
    else if (result?.isDismissed && result?.dismiss === 'cancel') {
      console.log("cancel");
    }
  }

  const uploadImage = async (type) => {
    try {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/png,image/jpeg,image/jpg';

      return new Promise((resolve, reject) => {
        input.onchange = async (event) => {
          try {
            const file = event.target.files[0];

            // Validation checks
            if (!file) {
              toast.error("No file selected");
              return;
            }

            // Check file type
            const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            if (!validTypes.includes(file.type)) {
              toast.error("Invalid file type");
              return;
            }

            // Check file size (5MB = 5 * 1024 * 1024 bytes)
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
              toast.error("File size must be less than 5 MB");
              return;
            }

            const imageUrl = URL.createObjectURL(file);

            if (type === "Cover") {
              setImages((prev) => ({
                ...prev,
                coverImage: file,
                coverImageUrl: imageUrl,
              }));
            }
            else if (type === "Profile") {
              setImages((prev) => ({
                ...prev,
                profileImage: file,
                profileImageUrl: imageUrl,
              }));
            }

            toast.success(`${type} image uploaded successfully!`);

            // resolve(result);
          } catch (error) {
            toast.error("There was an error uploading the image");
            reject(error);
          }
        };

        // Trigger file input click
        input.click();
      });
    } catch (error) {
      toast.error("An unexpected error occurred");
    }
  };

  const handleUpdates = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    setLoading(true);

    const newFormData = new FormData();
    newFormData.append("userId", id);
    newFormData.append("name", formData.name);
    newFormData.append("userName", formData.userName);
    newFormData.append("bio", formData.bio);
    newFormData.append("websiteUrl", formData.websiteUrl);
    newFormData.append("twitterUrl", formData.twitterUrl);
    newFormData.append("telegramUrl", formData.telegramUrl);
    newFormData.append("coverImage", images.coverImage);
    newFormData.append("profileImage", images.profileImage);

    const result = await axios.patch(
      `${BASE_URL}/users/update`,
      newFormData,
      {
        headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
      }
    );

    console.log('result : ', result);
    const resultData = result?.data

    if (resultData?.errors) {
      toast.error(resultData?.errors[0]);
    } else if (resultData?.success) {
      setUser(resultData?.data?.user);
      setFormData({
        name: resultData?.data?.name || "",
        userName: resultData?.data?.userName || "",
        bio: resultData?.data?.bio || "",
        websiteUrl: resultData?.data?.websiteUrl || "",
        twitterUrl: resultData?.data?.twitterUrl || "",
        telegramUrl: resultData?.data?.telegramUrl || "",
      });
      setImages((prev) => ({
        ...prev,
        coverImageUrl: resultData?.data?.coverImage ? `${BASE_URL}/${resultData?.data?.coverImage}` : "",
        profileImageUrl: resultData?.data?.profileImage ? `${BASE_URL}/${resultData?.data?.profileImage}` : "",
      }));
      toast.success("Profile Updated Successfully");
    }
    fetchUser();
    setLoading(false);
  };

  console.log("images : ", images);

  return (
    <>
      {loading && <Loader />}
      <div className="row gy-4">

        <div className={`col-lg-4`}>
          <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
            <img
              src={images?.coverImageUrl || STANDARD_IMAGE_URL}
              alt="Cover"
              className="w-100 object-fit-cover hover:cursor-pointer"
              onClick={() => from === userPageType.UPDATE && handleImage("Cover")}
            />
            {from === userPageType.UPDATE &&
              <div className="position-absolute top-0 end-0 m-2">
                <button
                  className="rounded-circle bg-white p-4 hover:bg-gray-200 transition-colors duration-200 d-flex justify-content-center align-items-center"
                  title="Update Cover Image"
                  aria-label="Update Cover Image"
                  onClick={() => handleImage("Cover")}
                >
                  <Icon icon="mdi:pencil" className="text-xl text-gray-600" />
                </button>
              </div>
            }
            <div className="pb-24 ms-16 mb-24 me-16 mt--100">
              <div className="text-center border-bottom border-top">
                <div className="position-relative d-flex flex-column justify-content-center align-items-center">
                  <div className="position-relative">
                    <img
                      src={images?.profileImageUrl || "https://wow-dash.com/demo/assets/images/user-grid/user-grid-img14.png"}
                      alt="Profile"
                      className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover mb--24"
                      onClick={() => from === userPageType.UPDATE && handleImage("Profile")}
                    />
                    {from === userPageType.UPDATE &&
                      < button
                        className="rounded-circle edit-profile-btn bg-white p-4 hover:bg-gray-200 transition-colors duration-200 d-flex justify-content-center align-items-center"
                        title="Update Profile Image"
                        aria-label="Update Profile Image"
                        onClick={() => handleImage("Profile")}
                      >
                        <Icon icon="mdi:pencil" className="text-xl text-gray-600" />
                      </button>
                    }
                  </div>
                </div>
                <h6 className="mb-0 mt-16">{user?.name}</h6>
                <span className="text-secondary-light mb-16">{user?.userName}</span>
              </div>
              <div className="mt-24">
                <h6 className="text-xl mb-16">Personal Info</h6>
                <ul>
                  <li className="d-flex align-items-center gap-2 mt-4">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Name
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.name || "N/A"}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-4">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      User Name
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.userName || "N/A"}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-4">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Created At
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {new Date(user?.createdAt).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-4">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Wallet Address
                    </span>
                    <span className="me-2">:</span>
                    <div className="d-flex align-items-center w-70 text-secondary-light fw-medium ">
                      <span>
                        {user?.walletAddress
                          ? trimAddress(user?.walletAddress, 10, 8)
                          : "N/A"}
                      </span>
                      {user?.walletAddress && (
                        <button
                          onClick={() => copyToClipboard(user?.walletAddress)}
                          className="ms-3 p-0 border-0 bg-transparent "
                          style={{ lineHeight: 1 }}>
                          <IoCopyOutline />
                        </button>
                      )}
                    </div>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-6">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Bio
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.bio || "N/A"}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-6">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Website
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.websiteUrl || "N/A"}
                    </span>
                    {user?.websiteUrl && (
                      <button
                        onClick={() => copyToClipboard(user?.websiteUrl)}
                        className="ms-3 p-0 border-0 bg-transparent "
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-6">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Twitter
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.twitterUrl || "N/A"}
                    </span>
                    {user?.twitterUrl && (
                      <button
                        onClick={() => copyToClipboard(user?.twitterUrl)}
                        className="ms-3 p-0 border-0 bg-transparent "
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </li>
                  <li className="d-flex align-items-center gap-2 mt-6">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Telegram
                    </span>
                    <span>:</span>
                    <span className="w-70 text-secondary-light fw-medium">
                      {user?.telegramUrl || "N/A"}
                    </span>
                    {user?.telegramUrl && (
                      <button
                        onClick={() => copyToClipboard(user?.telegramUrl)}
                        className="ms-3 p-0 border-0 bg-transparent "
                        style={{ lineHeight: 1 }}>
                        <IoCopyOutline />
                      </button>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {from === userPageType.UPDATE && (
          <div className="col-lg-8">
            <div className="card h-100">
              <div className="card-body p-24">
                <ul
                  className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                  id="pills-tab"
                  role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link d-flex align-items-center px-24 active"
                      id="pills-edit-profile-tab"
                      data-bs-toggle="pill"
                      data-bs-target="#pills-edit-profile"
                      type="button"
                      role="tab"
                      aria-controls="pills-edit-profile"
                      aria-selected="true">
                      Edit Profile
                    </button>
                  </li>
                </ul>
                <div className="tab-content" id="pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="pills-edit-profile"
                    role="tabpanel"
                    aria-labelledby="pills-edit-profile-tab"
                    tabIndex={0}>
                    <form action="#" onSubmit={handleUpdates}>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="name"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Name
                              <span className="text-danger-600">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.name ? "is-invalid" : ""
                                }`}
                              id="name"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.name || "Not Provided"
                                  : "Enter Name"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.name}
                              onChange={handleValues}
                              name="name"
                            />
                            {errors.name && (
                              <div className="invalid-feedback">
                                {errors.name}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="name"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              User Name
                              <span className="text-danger-600">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.userName ? "is-invalid" : ""
                                }`}
                              id="userName"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.userName || "Not Provided"
                                  : "Enter User Name"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.userName}
                              onChange={handleValues}
                              name="userName"
                            />
                            {errors.userName && (
                              <div className="invalid-feedback">
                                {errors.userName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="bio"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Bio <span className="text-danger-600">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.bio ? "is-invalid" : ""
                                }`}
                              id="bio"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.bio || "Not Provided"
                                  : "Enter Bio Details"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.bio}
                              onChange={handleValues}
                              name="bio"
                            />
                            {errors.bio && (
                              <div className="invalid-feedback">
                                {errors.bio}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="websiteUrl"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Website <span className="text-danger-600">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.websiteUrl ? "is-invalid" : ""
                                }`}
                              id="websiteUrl"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.websiteUrl || "Not Provided"
                                  : "Enter Website URL"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.websiteUrl}
                              onChange={handleValues}
                              name="websiteUrl"
                            />
                            {errors.websiteUrl && (
                              <div className="invalid-feedback">
                                {errors.websiteUrl}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="twitterUrl"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Twitter
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.twitterUrl ? "is-invalid" : ""
                                }`}
                              id="twitterUrl"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.twitterUrl || "Not Provided"
                                  : "Enter Twitter URL"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.twitterUrl}
                              onChange={handleValues}
                              name="twitterUrl"
                            />
                            {errors.twitterUrl && (
                              <div className="invalid-feedback">
                                {errors.twitterUrl}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="mb-20">
                            <label
                              htmlFor="telegramUrl"
                              className="form-label fw-semibold text-primary-light text-sm mb-8">
                              Telegram
                            </label>
                            <input
                              type="text"
                              className={`form-control radius-8 ${errors.telegramUrl ? "is-invalid" : ""
                                }`}
                              id="telegramUrl"
                              placeholder={
                                from === userPageType.VIEW
                                  ? user?.telegramUrl || "Not Provided"
                                  : "Enter Telegram URL"
                              }
                              disabled={from === userPageType.VIEW}
                              value={formData?.telegramUrl}
                              onChange={handleValues}
                              name="telegramUrl"
                            />
                            {errors.telegramUrl && (
                              <div className="invalid-feedback">
                                {errors.telegramUrl}
                              </div>
                            )}
                          </div>
                        </div>
                      </div >
                      {from === userPageType.UPDATE && (
                        <div className="d-flex align-items-center justify-content-center gap-3">
                          <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                            disabled={loading || Object.keys(errors).length > 0}>
                            {loading ? "Saving..." : "Save"}
                          </button>
                        </div>
                      )}
                    </form >
                  </div >
                </div >
              </div >
            </div >
          </div >
        )}
      </div >
    </>
  );
};

export default ViewProfileLayer;
